import React from "react";
import { FormLabel, FormToggle, FormElement, FormInput, FormSubLabel } from "../../../components/StyledElements";
import { useAgents } from "contexts/AgentsContext";


export const CoreDetails = ({ style = {}, onSelectTab = () => { } }) => {
  const { updatedAgent, setUpdatedAgent } = useAgents();

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>

      <FormElement style={{ flexDirection: "column", display: "flex" }}>
        {
          updatedAgent?.document_count ? (
            <FormLabel label={`${updatedAgent.document_count} Items`} />
          ) : null}
        {
          updatedAgent?.collection_chunk_count ? (
            <FormLabel label={`${updatedAgent.collection_chunk_count} Chunked Items`} />
          ) : null}
      </FormElement>

      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={updatedAgent?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Name" />
        <FormInput type="text" placeholder="Enter agent name" value={updatedAgent?.name ?? ""}
          onChange={(e) => {
            setUpdatedAgent({ ...updatedAgent, name: e.target.value });
          }}
        />
      </FormElement>
      <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
        <FormElement style={{ width: "400px" }}>
          <FormLabel label="Save Memory" />
          <FormSubLabel label="If enabled, the agent will remember previous interactions and use that information to inform its responses." />

          <FormToggle
            checked={updatedAgent?.use_agent_memory ?? false}
            onChange={(e) => {
              setUpdatedAgent({ ...updatedAgent, use_agent_memory: e.target.checked });
            }}
          />
        </FormElement>
      </div>

      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter description"
          style={{ resize: "vertical" }}
          value={updatedAgent?.description ?? ""}
          onChange={(e) => {
            updatedAgent.description = e.target.value;
            setUpdatedAgent({ ...updatedAgent });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Identity" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter agent identity"
          style={{ resize: "vertical" }}
          value={updatedAgent?.identity ?? ""}
          onChange={(e) => {
            updatedAgent.identity = e.target.value;
            setUpdatedAgent({ ...updatedAgent });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Voice" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter the tone of voice used to respond to the user. For example, 'professional and concise' or 'friendly and casual'."
          style={{ resize: "vertical" }}
          value={updatedAgent?.voice ?? ""}
          onChange={(e) => {
            updatedAgent.voice = e.target.value;
            setUpdatedAgent({ ...updatedAgent });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
